import { message } from 'antd';

import axiosWithAuth from '@/lib/axios';

// 處理圖片上傳
export async function uploadImage(imageFile: File): Promise<string | null> {
  try {
    const formData = new FormData();
    formData.append('files', imageFile);
    const { data } = await axiosWithAuth.post(
      '/newUploads?type=realtimeMessages',
      formData
    );
    return data[0].showPath;
  } catch (error) {
    console.error(error);
    message.error('圖片上傳失敗');
    return null;
  }
}
